import { Theme } from '@logto/schemas';
import classNames from 'classnames';
import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import { LoadingIcon } from '@/components/LoadingLayer';

import * as styles from './index.module.scss';

type Props = {
  className?: string;
  connectorId: string;
  isLoading?: boolean;
};

const SocialLanding = ({ className, connectorId, isLoading = false }: Props) => {
  const { experienceSettings, theme } = useContext(PageContext);
  const connector = experienceSettings?.socialConnectors.find(({ id }) => id === connectorId);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.connector}>
        {connector ? (
          <img
            src={theme === Theme.Dark ? connector.logoDark ?? connector.logo : connector.logo}
            alt="logo"
            crossOrigin="anonymous"
          />
        ) : (
          connectorId
        )}
      </div>
      {isLoading && <LoadingIcon />}
    </div>
  );
};

export default SocialLanding;
